import { render, staticRenderFns } from "./MainButtons.vue?vue&type=template&id=70be20f1&scoped=true&"
import script from "./MainButtons.vue?vue&type=script&lang=js&"
export * from "./MainButtons.vue?vue&type=script&lang=js&"
import style0 from "./MainButtons.vue?vue&type=style&index=0&id=70be20f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be20f1",
  null
  
)

export default component.exports